import React from 'react';
import { X } from 'lucide-react';
import { SocialPlatform, PLATFORM_CONFIG, CORE_PLATFORMS, EXTRA_PLATFORMS } from './SocialLinks';

type SocialLinksEditorProps = {
  links: Record<string, string>;
  onChange: (links: Record<string, string>) => void;
};

export default function SocialLinksEditor({ links, onChange }: SocialLinksEditorProps) {
  const handleChange = (platform: string, value: string) => {
    onChange({
      ...links,
      [platform]: value
    });
  };

  const handleRemove = (platform: string) => {
    const newLinks = { ...links };
    delete newLinks[platform];
    onChange(newLinks);
  };

  const renderPlatformInput = (platform: SocialPlatform) => {
    const config = PLATFORM_CONFIG[platform];
    const Icon = config.icon;
    const value = links[platform] || '';

    return (
      <div key={platform} className="relative flex items-center">
        <Icon className={`absolute left-3 w-5 h-5 ${config.color}`} />
        <input
          type="url"
          value={value}
          onChange={(e) => handleChange(platform, e.target.value)}
          placeholder={`${config.label} URL`}
          className="w-full pl-10 pr-10 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-accent1 focus:border-transparent"
        />
        {value && (
          <button
            onClick={() => handleRemove(platform)}
            className="absolute right-3 p-1 text-gray-400 hover:text-gray-600 rounded-full"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
    );
  };

  return (
    <div className="space-y-4">
      <div className="space-y-3">
        <h4 className="font-medium text-gray-700">Core Platforms</h4>
        {CORE_PLATFORMS.map(renderPlatformInput)}
      </div>

      <div className="space-y-3">
        <h4 className="font-medium text-gray-700">Additional Platforms</h4>
        {EXTRA_PLATFORMS.map(renderPlatformInput)}
      </div>
    </div>
  );
}